import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { contextProvider } from "../../../context/ContextProvider";
import Register from "../../page/login/Register";
import { useContext } from "react";
import apiAntesala from "../../../config/ConfigPublic";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";

const RegisterController = () => {
  const navigation = useNavigate();
  const context = useContext(contextProvider);
  const { FORMs, VALIDATIONs, URLs } = context;

  const { tipo } = useParams();

  const { FORM_REGISTER } = FORMs;
  const { VALIDATION_FORM_REGISTER } = VALIDATIONs;

  const [loading, setLoading] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [recaptcha, setRecaptcha] = useState(null);
  const [urls, setUrls] = useState(URLs);
  const [form, setForm] = useState(JSON.parse(JSON.stringify(FORM_REGISTER)));
  const [validation, setValidation] = useState(
    JSON.parse(JSON.stringify(VALIDATION_FORM_REGISTER))
  );
  const [showPassword, setShowPassword] = useState(true);

  const fetch = async (setData, params, url, signal, loading) => {
    try {
      const response = await apiAntesala.get(url, {
        params,
        signal,
      });
      if (response.status == 201 || response.status == 200) {
        setData(response.data);
        if (loading) {
          loading(false);
        }
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Request aborted");
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };


  console.log(form);


  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "show":
        {
          e.preventDefault();
          setShowPassword(!showPassword);
        }
        break;
      case "registro":
        {
          e.preventDefault();

          if (!recaptcha) {
            return Alerts({
              msg: "Alert",
              title: "El recaptcha es obligatorio",
              code: "401",
              type: "error",
            });
          }

          let error = false;
          let validations = validation;
          let validateForm = form;

          if (tipo == 1) {
            validateForm.rol[0] = "esp";
          }

          Object.keys(validateForm).map((key) => {
            if (
              validateForm[key][1] == "required" &&
              validateForm[key][0].trim() == ""
            ) {
              validations[key]["msg"] = `El campo ${key} es obligatorio`;
              validations[key]["status"] = true;
              error = true;
            }
          });

          if (tipo == 2) {
            const requiredFields = ['provincia', 'localidad', 'direccion', 'rol'];
            requiredFields.forEach((field) => {
              if (!validateForm[field][0] || validateForm[field][0].trim() === "") {
                validations[field]["msg"] = `El campo ${field} es obligatorio para este tipo de usuario`;
                validations[field]["status"] = true;
                error = true;
              }
            });
          }

          setValidation({
            ...validation,
          });

          if (error) {
            return Alerts({
              msg: "Alert",
              title: "Todos los campos son obligatorios",
              code: "401",
              type: "error",
            });
          }

          let dataForm = new FormData();
          dataForm.append("email", validateForm.email[0]);
          dataForm.append("nombre", validateForm.nombre[0]);
          dataForm.append("apellido", validateForm.apellido[0]);
          if (validateForm.telefono[0])
            dataForm.append("telefono", validateForm.telefono[0]);
          dataForm.append("direccion", validateForm.direccion[0]);
          dataForm.append("localidad", validateForm.localidad[0]);
          dataForm.append("provincia", validateForm.provincia[0]);
          dataForm.append("password", validateForm.password[0]);
          dataForm.append("repeat_password", validateForm.confirm_password[0]);
          dataForm.append("tipo", validateForm.rol[0]);
          dataForm.append("grecaptcha", recaptcha);

          const response = await RestPrivateAntesala({
            method: "post",
            url: "/auth/registro",
            formData: dataForm,
            setLoading: setLoading,
          });

          if (response.status == 201 || response.status == 200) {
            Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "401",
              type: "success",
            });

            return navigation("/");
          } else {
            Object.keys(response.data.msg).map((key) => {
              if (
                response?.data?.msg[key][0] ==
                "The email has already been taken."
              ) {
                return Alerts({
                  msg: "Warning",
                  title: "El email ya se encuentra registrado",
                  code: "201",
                  type: "error",
                });
              } else {
                return Alerts({
                  msg: "Warning",
                  title: "Ocurrio un error vuelve a intentarlo mas tarde",
                  code: "201",
                  type: "error",
                });
              }
            });
          }
        }
        break;
    }
  };

  const onChange = (e, value) => {
    switch (e.target.name) {
      case "nombre":
      case "apellido":
      case "telefono":
      case "direccion":
      case "provincia":
      case "localidad":
      case "rol":
      case "password":
      case "confirm_password":
      case "email":
        {
          //setValidation(JSON.parse(JSON.stringify(VALIDATIONS.VALIDATION_LOGIN)))
          let setValue = form;
          setValue[e.target.name][0] = e.target.value;

          return setForm({
            ...form,
            [e.target.name]: setValue[e.target.name],
          });
        }
        break;
    }
  };

  useEffect(() => {
    if (!provincias) {
      fetch(setProvincias, {}, "/provincias");
    }
  }, []);
  return (
    <Register
      navigation={navigation}
      onClick={onClick}
      onChange={onChange}
      setShowPassword={setShowPassword}
      showPassword={showPassword}
      form={form}
      setForm={setForm}
      validation={validation}
      provincias={provincias ?? []}
      tipo={tipo}
      loading={loading}
      setRecaptcha={setRecaptcha}
    />
  );
};

export default RegisterController;
